import { useRouteMatch } from 'react-router';

import { useCampaignStates } from '../../templates';
import { MonitoringTemplate } from '../../templates';
import { useCampaignColumns } from './useCampaignColumns';
import { useCampaignMonitoring } from './useCampaignMonitoring';
import type { ItemType } from './useCampaignMonitoring';

type Props = { id: string };

const CampaignMonitoringComponent: React.FC<Props> = ({ id }) => {
  const campaignResult = useCampaignMonitoring(id);
  const { statesMap, stateOptions } = useCampaignStates(id);

  const { rawData: data } = campaignResult;
  const columns = useCampaignColumns(id, data?.columns, statesMap);

  return (
    <MonitoringTemplate<ItemType>
      campaignId={id}
      columns={columns}
      listResult={campaignResult}
      stateOptions={stateOptions}
    />
  );
};

const CampaignMonitoring = () => {
  const {
    params: { id },
  } = useRouteMatch<{ id: string }>();

  return id ? <CampaignMonitoringComponent key={id} id={id} /> : null;
};

export default CampaignMonitoring;
